import { render, staticRenderFns } from "./AddMaterialsToJobModal.vue?vue&type=template&id=13b1b713&scoped=true&class=fill-height&"
import script from "./AddMaterialsToJobModal.vue?vue&type=script&lang=ts&"
export * from "./AddMaterialsToJobModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddMaterialsToJobModal.vue?vue&type=style&index=0&id=13b1b713&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b1b713",
  null
  
)

export default component.exports